
  import Events from '@/events/Events';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';
  import ScreenSize from '@/mixins/ScreenSize';
  export default {
    components: {
      DialogsBaseSection,
      CheckboxRichText: () => import('@/components/elements/CheckboxRichText'),
    },
    mixins: [ScreenSize],
    props: {
      openDirectDialog: {
        type: Boolean,
        required: false,
        default: false,
      },
      topic: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {
        section: {},
        buttonDisabled: false,
        questionDialog: false,
        availableTopics: [
          this.$t('general_question.topics_general_request'),
          this.$t('general_question.topics_order_job_advertisement_package'),
          this.$t('general_question.topics_order_job_advertisement_quota'),
          this.$t(
            'general_question.topics_order_special_forms_of_advertising_features'
          ),
          this.$t('general_question.topics_order_booster_campaign'),
          this.$t('general_question.topics_order_pb_quota_search'),
          this.$t('general_question.topics_help'),
          this.$t('general_question.topics_new_registration'),
          this.$t('general_question.topics_invoices'),
          this.$t('general_question.topics_master_data_change'),
          this.$t('general_question.topics_appointment_request_consultation'),
          this.$t('general_question.topics_misc'),
        ],
        questionData: {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          message: '',
          checkbox: false,
        },
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('general-contact-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    created() {
      if (this.openDirectDialog) {
        this.questionDialog = true;
      }
      if (this.topic && this.topic !== '') {
        const selectedTopic = this.availableTopics.find((topicString) =>
          topicString.includes(this.$t('general_question.topics_' + this.topic))
        );
        this.questionData.topic = selectedTopic;
      }
    },
    methods: {
      openDialog(on) {
        return ($event) => {
          on.click($event);
          this.questionDialog = true;
        };
      },
      closeDialog() {
        this.questionDialog = false;
        const currentHash = this.$route.hash;
        this.$router.push({
          path: this.$route.path + currentHash ? currentHash : '',
        });
      },
      resetForm() {
        this.$refs.generalContactQuestion.resetValidation();
        this.$refs.generalContactQuestion.$children.forEach((child) => {
          if (Object.prototype.hasOwnProperty.call(child, 'reset')) {
            child.reset();
          }
        });
        this.questionData = {
          name: '',
          company: '',
          email: '',
          phone: '',
          topic: '',
          message: '',
          checkbox: false,
        };
      },
      async sendQuestion() {
        this.buttonDisabled = true;
        setTimeout(() => {
          this.buttonDisabled = false;
        }, 5000);

        await this.$store
          .dispatch('api/organization/generalContact', {
            data: this.questionData,
          })
          .then(() => {
            this.$notifications.showNotification({
              message: this.$t('organization.question_general_success'),
              color: 'success',
              timeout: 3000,
            });
            this.$emitWithClientData(
              Events.GeneralContactRequest,
              this.questionData
            );
            this.closeDialog();
            this.resetForm();
            this.$router.push({
              path: this.$route.path,
              query: {},
            });
          })
          .catch((e) => {
            if (e.response.status !== 200) {
              this.$notifications.showNotification({
                message: this.$t('organization.question_general_error'),
                color: 'error',
                timeout: 5000,
              });
            }
          });
      },
    },
  };
